var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { Menu as MuiMenu } from '@mui/material';
/**
 * Pigment [Menu](https://pigment.customink.com/?path=/docs/components-menu)
 */
var Menu = function (_a) {
    var anchorEl = _a.anchorEl, _b = _a.open, open = _b === void 0 ? false : _b, _c = _a.disableScrollLock, disableScrollLock = _c === void 0 ? false : _c, onClose = _a.onClose, children = _a.children, props = __rest(_a, ["anchorEl", "open", "disableScrollLock", "onClose", "children"]);
    return (React.createElement(MuiMenu, __assign({ open: open, disableScrollLock: disableScrollLock, anchorEl: anchorEl, onClose: onClose, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, transformOrigin: { vertical: 'top', horizontal: 'center' }, disableAutoFocusItem: true, slotProps: {
            paper: {
                style: {
                    borderRadius: '8px',
                },
                elevation: 4,
            },
        } }, props), children));
};
export default Menu;
//# sourceMappingURL=Menu.js.map